
import { Component, Vue } from 'vue-property-decorator';
import Header from './components/Header.vue';
import GridCard from './components/GridCard.vue';
import FilterProduct from './components/FilterProduct.vue';
import { dataFilter } from '@/utils/dataFilter';

@Component({
  components: {
    Header, GridCard, FilterProduct
  },
})
export default class App extends Vue {
  private dataFilter = dataFilter;
}
